require('../../common/js/browser-checks');

const _ = require('lodash');
const addPaymentsTaskHandler = require('@/lib/OnlineQueue/Handlers/addPaymentsTaskHandler');
const AgentInfoDirective = require('@/epos/js/directives/AgentInfoDirective');
const angularAppFactory = require('@/bootstrap/angularAppFactory');
const AppInstanceChecker = require('@/libraries/DigiTickets/AppInstanceChecker');
const bootstrap = require('@/1-bootstrap');
const CashCtrl = require('@/controllers/modal/PaymentMethods/CashCtrl');
const CloverPaymentCtrl = require('@/controllers/modal/PaymentMethods/CloverPaymentCtrl');
const confirmOrderTaskHandler = require('@/lib/OnlineQueue/Handlers/confirmOrderTaskHandler');
const createOrderTaskHandler = require('@/lib/OnlineQueue/Handlers/createOrderTaskHandler');
const CustomerScreenStages = require('@/lib/CustomerScreen/CustomerScreenStages');
const DeviceCtrl = require('@/epos/js/controllers/DeviceCtrl');
const DojoPaymentCtrl = require('@/controllers/modal/PaymentMethods/DojoPaymentCtrl');
const DojoWebPosPaymentCtrl = require('@/controllers/modal/PaymentMethods/DojoWebPosPaymentCtrl');
const EposIndexCtrl = require('@/epos/js/controllers/EposIndexCtrl');
const EventNames = require('@/lib/Events/EventNames');
const FlexiVoucherCtrl = require('@/controllers/modal/PaymentMethods/FlexiVoucherCtrl');
const GiftVoucherPaymentCtrl = require('@/controllers/modal/PaymentMethods/GiftVoucherPaymentCtrl');
const GoCardlessCtrl = require('@/controllers/modal/PaymentMethods/GoCardlessCtrl');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');
const MellonWebECRCtrl = require('@/controllers/modal/PaymentMethods/MellonWebECRCtrl');
const OnlineTaskType = require('@/lib/OnlineQueue/OnlineTaskType');
const OrderDetailCtrl = require('@/epos/js/controllers/OrderDetailCtrl');
const OrderValidator = require('@/lib/Validation/OrderValidator');
const PaymentExpressCtrl = require('@/controllers/modal/PaymentMethods/PaymentExpressCtrl');
const PayPalHereCtrl = require('@/controllers/modal/PaymentMethods/PayPalHereCtrl');
const PayyoPaymentCtrl = require('@/controllers/modal/PaymentMethods/PayyoPaymentCtrl');
const redemptionTaskHandler = require('@/lib/OnlineQueue/Handlers/redemptionTaskHandler');
const registerEposRoutes = require('@/epos/js/routes');
const runAppCommon = require('@/run-common');
const SagePayCtrl = require('@/controllers/modal/PaymentMethods/SagePayCtrl');
const saveTradingSessionEntryTaskHandler = require('@/lib/OnlineQueue/Handlers/saveTradingSessionEntryTaskHandler');
const Sentry = require('@sentry/browser');
const TescoVoucherUkPaymentCtrl = require('@/controllers/modal/PaymentMethods/TescoVoucherUkPaymentCtrl');
const TradingSessionEvent = require('@/lib/TradingSessions/TradingSessionEvent');
const TradingSessionEventType = require('@/lib/TradingSessions/TradingSessionEventType');
const VerifonePaymentCtrl = require('@/controllers/modal/PaymentMethods/VerifonePaymentCtrl');
const VoucherCtrl = require('@/controllers/modal/PaymentMethods/VoucherCtrl');
const WorldpayPaymentCtrl = require('@/controllers/modal/PaymentMethods/WorldpayPaymentCtrl');
const { container } = require('@/container');
const { disableSignProPrintRouting } = require('@/lib/Printing');
const { SellCtrl } = require('@/epos/js/controllers/SellCtrl');
const { VuePlaceholderCtrl } = require('@/epos/js/controllers/VuePlaceholderCtrl');

bootstrap();

/**
 * Create the AngularJS app.
 *
 * @type {angular.Module}
 */
const app = angularAppFactory(registerEposRoutes);

// Register epos only controllers.
app.controller('DeviceCtrl', DeviceCtrl);
app.controller('EposIndexCtrl', EposIndexCtrl);
app.controller('OrderDetailCtrl', OrderDetailCtrl);
app.controller('SellCtrl', SellCtrl);
app.controller('VuePlaceholderCtrl', VuePlaceholderCtrl);

// Register controllers that will be used in an ng-controller directive in a template.
app.controller('CashCtrl', CashCtrl);
app.controller('CloverPaymentCtrl', CloverPaymentCtrl);
app.controller('DojoPaymentCtrl', DojoPaymentCtrl);
app.controller('DojoWebPosPaymentCtrl', DojoWebPosPaymentCtrl);
app.controller('FlexiVoucherCtrl', FlexiVoucherCtrl);
app.controller('GiftVoucherPaymentCtrl', GiftVoucherPaymentCtrl);
app.controller('GoCardlessCtrl', GoCardlessCtrl);
app.controller('MellonWebECRCtrl', MellonWebECRCtrl);
app.controller('PaymentExpressCtrl', PaymentExpressCtrl);
app.controller('PayPalHereCtrl', PayPalHereCtrl);
app.controller('PayyoPaymentCtrl', PayyoPaymentCtrl);
app.controller('SagePayCtrl', SagePayCtrl);
app.controller('TescoVoucherUkPaymentCtrl', TescoVoucherUkPaymentCtrl);
app.controller('VerifonePaymentCtrl', VerifonePaymentCtrl);
app.controller('VoucherCtrl', VoucherCtrl);
app.controller('WorldpayPaymentCtrl', WorldpayPaymentCtrl);

// Register EPOS-only directives.
// The name used here will become the name you use in HTML to use the directive, but converted to kebab-case.
// e.g. dtAgentInfo is used as <dt-agent-info>
// These should be prefixed with 'dt' to prevent collisions with any directives in third party packages, or any future
// HTML elements with the same name.
app.directive('dtAgentInfo', AgentInfoDirective);

// Register EPOS-only services.
app.service('orderValidator', OrderValidator);

app.run(
    /**
     * @param $injector
     * @param $location
     * @param $rootScope
     * @param {AgentService} agentService
     * @param {AppConfig} appConfig
     * @param {CartService} cartService
     * @param {CurrentDevice} currentDevice
     * @param {CustomerScreenDataService} customerScreenDataService
     * @param {DeviceLockService} deviceLockService
     * @param {DeviceLoginListener} deviceLoginListener
     * @param {DeviceManager} deviceManager
     * @param {Hydrator} hydrator
     * @param {KeyboardInputDetector} keyboardInputDetector
     * @param {LangService} langService
     * @param {NavigationService} navigationService
     * @param {OnlineQueue} onlineQueue
     * @param {OrderInProgressStasher} orderInProgressStasher
     * @param {PrintRouter} printRouter
     * @param {TradingSessionManager} tradingSessionManager
     * @param {UserService} userService
     * @param {VerifoneAuthHandler} verifoneAuthHandler
     * @param {VuexService} vuexService
     */
    function (
        $injector,
        $location,
        $rootScope,
        agentService,
        appConfig,
        cartService,
        currentDevice,
        customerScreenDataService,
        deviceLockService,
        deviceLoginListener,
        deviceManager,
        hydrator,
        keyboardInputDetector,
        langService,
        navigationService,
        onlineQueue,
        orderInProgressStasher,
        printRouter,
        tradingSessionManager,
        userService,
        verifoneAuthHandler,
        vuexService
    ) {
        $injector.invoke(runAppCommon);

        const logger = logFactory('EPOS');

        // Ensure that only one instance of the EPOS screen is running (unless we're in dev mode).
        if (!appConfig.isDev) {
            let appInstanceChecker = $injector.instantiate(AppInstanceChecker);
            appInstanceChecker.init(window, 'epos');
        }

        // Register the online task type handlers and start up the online queue.
        onlineQueue.registerHandler(OnlineTaskType.ADD_PAYMENTS, addPaymentsTaskHandler);
        onlineQueue.registerHandler(OnlineTaskType.CONFIRM_ORDER, confirmOrderTaskHandler);
        onlineQueue.registerHandler(OnlineTaskType.CREATE_ORDER, createOrderTaskHandler);
        onlineQueue.registerHandler(OnlineTaskType.REDEMPTION, redemptionTaskHandler);
        onlineQueue.registerHandler(OnlineTaskType.SAVE_TRADING_SESSION_ENTRY, saveTradingSessionEntryTaskHandler);
        onlineQueue.init();

        // Update the queued task count in the Vuex store when the queue is modified.
        const updateVuexQueuedTaskCount = async () => {
            const queuedTaskCount = await onlineQueue.countQueuedTasks();
            vuexService.commit('onlineQueue/setQueuedTaskCount', queuedTaskCount);
        };
        $rootScope.$on(EventNames.ONLINE_QUEUE_MODIFIED, updateVuexQueuedTaskCount);
        updateVuexQueuedTaskCount();

        // Attempt to connect to ProPoint agent now.
        agentService.connectToAgent()
            .catch((err) => {
                // Agent not available. This is probably fine. If something needs it it will complain louder.
                console.warn('ProPoint agent not available.', err);
            });

        // Add listeners to run on user login when both user and device are ready.
        deviceLoginListener.addListener(() => {
            verifoneAuthHandler.login();
        });

        // Callback for when the user logs in.
        // Device may not be selected yet.
        $rootScope.$on(
            EventNames.USER_LOGGED_IN,
            /**
             * @param event
             * @param {{user: User, fromCache: boolean}} data
             */
            function (event, data) {
                let user = data.user;

                // Inform Sentry of the current user
                Sentry.setUser({
                    // id and username are standard Sentry fields.
                    // See: https://docs.sentry.io/platforms/native/enriching-events/identify-user/#id
                    id: user.ID,
                    username: user.username,
                    // Additional fields can also be stored against the user, but they are not searchable.
                    companyName: user.company.name,
                    branchName: userService.currentBranch ? userService.currentBranch.name : null,
                });
                // Set the companyID as a Sentry tag.
                Sentry.setTag('companyID', user.company.ID);
                // userID is already searchable as the user.id field.
                // branchID is set on the ORDER_BRANCH_CHANGED event.
                // deviceID is set on the DEVICE_SET event.

                cartService.setUser(user);
                customerScreenDataService.updateState(
                    /**
                     * @param {CustomerScreenState} state
                     */
                    (state) => {
                        state.company = user.company;
                        state.currentBranch = userService.currentBranch;
                        state.currentUser = userService.currentUser;
                    }
                );

                langService.setLanguageFromBranch(userService.currentBranch);

                if (!data.fromCache) {
                    // This was a new login, not just loading the user from the cache.
                    // We need to log a USER_LOGIN trading session event, but the device might not have been selected.
                    if (currentDevice.isSet()) {
                        // Device is already selected, log now.
                        tradingSessionManager.saveEvent(
                            (new TradingSessionEvent(TradingSessionEventType.USER_LOGIN))
                                .setOperatorID(user.ID)
                        ).catch(() => {});
                    } else {
                        // The Device and TradingSessionID aren't set yet so we can't log anything yet.
                        // When they are set this will be called again.
                    }
                }

                deviceLoginListener.trigger();

                if (userService.currentUserSession?.isLocked) {
                    // Lock the screen again.
                    console.log('User session was locked when loaded. Re-locking device.');
                    deviceLockService.lockDevice();
                }
            }
        );

        $rootScope.$on(EventNames.ORDER_BRANCH_CHANGED, function () {
            customerScreenDataService.updateState((state) => {
                state.currentBranch = userService.currentBranch;
            });
            langService.setLanguageFromBranch(userService.currentBranch);

            // Set the branchID as a Sentry tag.
            Sentry.setTag('branchID', userService.currentBranch?.ID || null);
        });

        $rootScope.$on(
            EventNames.DEVICE_SET,
            function (event, data) {
                // Inform Sentry of the newly chosen device.
                Sentry.setContext('device', {
                    deviceID: data.device.ID,
                    deviceName: data.device.name,
                });
                // Set the deviceID as a Sentry tag.
                Sentry.setTag('deviceID', data.device.ID);

                // When a device has been selected, use the print configuration from that device.
                printRouter.loadFromDevice(data.device);

                // PROP-1753 - disable Sign Pro print routing if Entersoft is enabled.
                if (container.eInvoicingService.inUseForCompany()) {
                    disableSignProPrintRouting(printRouter);
                }

                // PROP-1761 - regenerate the cart thirdPartyRef when the device is set because this is generated
                // too early and does not include the device ID.
                cartService.regenerateCurrentCartThirdPartyRef();

                // Update the device info.
                deviceManager.sendDeviceInfo();

                deviceLoginListener.trigger();

                deviceLockService.setAutoLockAfterMinutes(data.device.autoLockAfterMinutes);
            }
        );

        // eslint-disable-next-line unused-imports/no-unused-vars
        $rootScope.$on('$routeChangeStart', function (event, next) {
            // Previously used to trigger a Google Analytics gtag() call.
        });

        /**
         * This checks if the same route is being loaded constantly (ie. redirect loop),
         * if is it the same every time for 3 times then it will prevent the next change.
         *
         * Otherwise, it will update the previous set with the new location and start again.
         *
         * @type {{next: string, current: string, count: number}}
         */
        let previousSet = { next: '', current: '', count: 0 };
        $rootScope.$on('$locationChangeStart',
            /**
             * @param {Event} ev
             * @param {string} next
             * @param {string} current
             */
            function (ev, next, current) {
                let requestedPath = $location.path();
                if (requestedPath && !navigationService.isNavigationAllowed(requestedPath)) {
                    ev.preventDefault();
                    return;
                }

                logger.debug(
                    'Switched page from ' + current + ' to ' + next
                );

                if (previousSet.next === next && previousSet.current === current) {
                    if (previousSet.count === 3) {
                        ev.preventDefault();
                        previousSet.count = 0;
                    }
                    previousSet.count++;
                }

                previousSet.next = next;
                previousSet.current = current;
            });

        // Initializing the user (loading an existing user from the cache) now happens in EposIndexCtrl.

        // Initialize the current device (loading from cache) now happens in EposIndexCtrl.

        customerScreenDataService.setStage(CustomerScreenStages.WAIT);

        // Catch any unauthorized API requests and trigger a logout.
        // It means the API key is no longer valid. The user probably logged in elsewhere.
        $rootScope.$on(
            EventNames.API_REQUEST_UNAUTHORIZED,
            /**
             * @param {Event} event
             * @param {{data:any, config:{url: string, params: any}}} response The response might be from Axios
             *      or angular-resource, but they are mostly compatible.
             */
            (event, response) => {
                console.log('API Request Unauthorized', response);

                const currentUsername = userService.getUsername();

                // If the request fails we will logout the user.
                // Check the request to make sure the apiKey that failed was the current user's apiKey.
                // If the request used some other apiKey and failed we don't want to logout.
                if (
                    userService.isLoggedIn()
                    && response
                    && response.config
                    && response.config.params
                    && response.config.params.apiKey
                    && response.config.params.apiKey === userService.getApiKey()
                ) {
                    userService.setAutofillLoginUsername(currentUsername);
                    userService.setLoginErrorMessageKey('LOGIN.ERROR__API_KEY_INVALID');

                    // Display "Please wait..." while logging out instead of "Logging out..." because the user
                    // doesn't really want to be logging out!
                    userService.logout('LOGIN.LOGGING_OUT__FORCED');
                }

                // If the request failed and said the device is no longer valid we will logout the user and
                // clear the current device.
                // Check the request to make sure the deviceGuid that failed was the current device's deviceGuid.
                // If the request used some other deviceGuid and failed we don't want to clear the device.
                if (
                    currentDevice.isSet()
                    && response
                    && response.data
                    && response.data.hasOwnProperty('deviceIsValid')
                    && !response.data.deviceIsValid
                    && response.config
                    && response.config.params
                    && response.config.params.deviceGuid
                    && response.config.params.deviceGuid === currentDevice.getDeviceGuid()
                ) {
                    // The API has told us the current device is no longer valid, so clear it
                    currentDevice.clearDevice();

                    // We'll logout the user so they can login again and go back to the device screen.
                    userService.setAutofillLoginUsername(currentUsername);
                    userService.setLoginErrorMessageKey('LOGIN.ERROR__DEVICE_INVALID');
                    userService.logout('LOGIN.LOGGING_OUT__FORCED');
                }
            }
        );

        $rootScope.$on(
            EventNames.ITEMS_SYNCED,
            () => {
                // Run some checks on the items data.
                container.itemOptionConfigValidator.validateAndDisplayErrors();
            }
        );

        $rootScope.$on(
            EventNames.EPOS_DATA_SYNCED,
            () => {
                // The sell screen caches these counts, so clear them post sync.
                window.rootVueStore.commit('cartOffers/setManualOrderOffersCount', null);
                window.rootVueStore.commit('sell/setFieldsCount', null);
            }
        );

        let initialLoader = document.getElementById('initial-loader');
        if (initialLoader) {
            initialLoader.parentNode.removeChild(initialLoader);
        }

        /**
         * See https://digitickets.atlassian.net/browse/PROP-396
         */
        $rootScope.onPrintingWorkaroundButtonClick = () => {
            // Do nothing
        };

        keyboardInputDetector.initialize(
            {
                // There really isn't much difference between these 2 regexs.
                // Maybe we should remove the difference and just listen for the same event in both places?
                '^[\\w ]{4,14}$': EventNames.BARCODE_SCANNED,
                '^[A-Z0-9]{9,14}$': EventNames.RFID_TAG_SCANNED,
            }
        );

        container.deviceLoginListener.addListener(async () => {
            const orderInProgress = orderInProgressStasher.getOrderInProgress();
            if (orderInProgress?.stashedCart) {
                // Found a stashed cart in the user's session.
                // Import that to the cart service as the current cart.
                console.log('Restoring stashed cart from user session', orderInProgress.stashedCart);
                await cartService.populateFromStash(orderInProgress.stashedCart);
                console.log('Stashed cart from user session restored', cartService.currentCart);
            }
        });

        // Set up the cart service to update the orderInProgress.
        // TODO: This can be removed in PROP-2009.
        const debouncedSetOrderInProgressCart = _.debounce(
            () => {
                orderInProgressStasher.setCart(cartService);
            },
            100
        );
        cartService.onChange(() => {
            debouncedSetOrderInProgressCart();
        });

        // Now AngularJS is all fired up, start Vue.
        require('@/epos/vue/eposVueInit');
    }
);
